/*
 * @Author: ylq
 * @Date: 2022-09-19 15:35:08
 * @Desc: DESC
 * @Last Modified by: ylq
 * @Last Modified time: 2024-03-23 08:30:32
 */
const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');
const DEFAULT_PAGE = () => import('@/layout/page.vue');

const LEADS = {
  path: '/leads',
  name: 'leads',
  component: DEFAULT_LAYOUT,
  redirect: { name: 'leads-list' },
  meta: {
    title: '线索',
    requiresAuth: true,
    // roles: 'clue',
    order: 2
  },
  children: [
    {
      path: 'index',
      name: 'leads-list-wrap',
      component: DEFAULT_PAGE,
      redirect: { name: 'leads-list' },
      meta: {
        hideChildrenInMenu: true,
        requiresAuth: true,
        roles: 'clue',
        title: '销售线索'
      },
      children: [
        {
          path: '',
          name: 'leads-list',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 1 },
          meta: {
            requiresAuth: true,
            roles: 'clue:view',
            title: '销售线索'
          }
        },
        {
          path: ':id/collaborators',
          name: 'leads-index-detail-collaborators',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 1 },
          meta: {
            requiresAuth: true,
            roles: 'clue:view',
            title: '销售线索详情'
          }
        },
        {
          path: ':id',
          name: 'leads-index-detail',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 1 },
          meta: {
            requiresAuth: true,
            roles: 'clue:view',
            title: '销售线索详情'
          }
        },

        {
          path: 'conversion-:opSwitch-:businessId-:entity-:id',
          name: 'conversion',
          component: () => import('@/views/leads/clue-conversion/clue-conversion.vue'),
          meta: {
            requiresAuth: true,
            title: '线索转化',
            roles: 'clue:transform',
            hideInMenu: true
          }
        }
      ]
    },
    {
      path: 'pool',
      name: 'leads-pool',
      component: DEFAULT_PAGE,
      redirect: { name: 'leads-pool-list' },
      meta: {
        hideChildrenInMenu: true,
        requiresAuth: true,
        roles: 'cluePool',
        title: '线索池'
      },
      children: [
        {
          path: '',
          name: 'leads-pool-list',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 101 },
          meta: {
            requiresAuth: true,
            title: '线索池',
            roles: 'cluePool:view'
          }
        },
        {
          path: ':id',
          name: 'leads-pool-detail',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 101 },
          meta: {
            requiresAuth: true,
            title: '线索池详情',
            roles: 'cluePool:view'
          }
        }
      ]
    }
  ]
};

export default LEADS;
